<app-onboarding-profile-shell [showBack]="true"
  (back)="handleBack()">
  <div shellHeading
    class="tw-font-bold tw-leading-1.2 tw-text-gray-800"
    [class.tw-text-600]="isDravidianScriptUser()"
    [class.tw-text-700]="!isDravidianScriptUser()"
    i18n="@@tellUsYourNameHeading">Tell us <br/> your name</div>

  <input class="tw-m-0 tw-h-12 tw-w-full tw-rounded-2.5 tw-border tw-border-solid tw-bg-gray-100 tw-px-3 tw-font-body tw-text-300 tw-text-gray-800 placeholder:tw-text-left placeholder:tw-text-300 placeholder:tw-font-normal placeholder:tw-text-gray-400"
    #nameInput
    id="nameInput"
    name="patientName"
    type="text"
    autocomplete="off"
    [class.tw-border-gray-300]="!isFilled() && !hasError()"
    [class.tw-border-teal-400]="isValidAndFilled()"
    [class.tw-border-orange-500]="hasError()"
    [ngModel]="patientName()"
    (ngModelChange)="onNameChange($event)"
    (paste)="onInputPaste($event)"
    placeholder="write your name here"
    i18n-placeholder="@@writeYourNameHere" />
  @if (hasError()) {
    <app-onboarding-profile-field-error id="nameError">
      @if (errorMessage() === GenderFormErrorMessages.numberInName) {
        <span i18n="@@nameErrorSpecialCharactersV2">Enter only letters in your name. Do not use numbers or special characters (like &#64;, #, /, ,).</span>
      }
      @if (errorMessage() === GenderFormErrorMessages.emptyName) {
        <span i18n="@@nameErrorEmptyNameV2">Enter your name to continue</span>
      }
      @if (errorMessage() === GenderFormErrorMessages.maxNameLength) {
        <span i18n="@@nameErrorLengthLimitV2">Please enter only up to 3 words in your name</span>
      }
    </app-onboarding-profile-field-error>
  }

  <button shellFooter
    csButton
    id="continueBtn"
    type="button"
    class="tw-w-full"
    [loading]="loading()"
    (click)="handleContinue()"><span i18n="@@continueNew">Continue</span>
  </button>
</app-onboarding-profile-shell>
